<template>
  <div class="page">
    <div class="service_contract">
      <div class="service_title">好声音学院服务协议</div>
      <div class="service_nav">
        <div class="text_14">用户须知</div>
        <span class="text_12">
          欢迎您使用好声音学院为您提供的服务（以下简称“服务”或“本服务”）
          请仔细阅读本协议的全部条款，确保您充分理解本协议中各条款。请您审慎阅读并选择接受或不接受本协议。特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、同意开通、法律适用和争议解决条款等。如不同意有关条款，请停止使用本网站或小程序提供的服务。您一旦注册后使用本网站提供的内容，包括但不限于浏览信息、下载内容、使用本产品提供的第三方网站链接等，即视为您对本协议的接受，并同意接受本协议各项条款的约束。
          在使用”好声音学院“提供的服务之前，请务必认真阅读本协议的全部内容。如您对本协议有任何疑问，请向官方contact@singchina.com咨询。本协议生效后，则不接受以未阅读或不接受本协议的内容为由，主张本协议无效或要求撤销本协议。
          本协议可由“好声音学院”随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，您可在本网站查阅最新版协议条款。在“好声音学院”修改协议条款后，如果您不接受修改后的条款，请立即停止使用“好声音学院”提供的服务，您继续使用“好声音学院”提供的服务将被视为接受修改后的协议。
        </span>
        <div class="text_14">用语释义</div>
        <span class="text_12">
          除本协议另有规定外，下列用语应当具有以下释义：
          1、“好声音学院”是指由上海声众网络科技有限公司合法拥有并运营的、标注名称为“好声音学院”的小程序、应用程序、社交媒体账号、以及域名为singchina.com、singchina.vip和singschool.cn的网站。公司有权对应用程序、域名及网站名称单方变更（包括但不限于更名、新增等）。产品服务包括但不限于：“好声音学院”网站和小程序、线上或线下活动、数据和信息服务等。
          2、您是指符合“好声音学院”规定的条件、同意遵守本协议的约定、自愿申报注册成为“好声音学院”并使用“好声音学院”平台服务的主体。包括自然人、法人和其他组织等。访客等非注册主体构成本协议所称的广义您，并受本协议约束。
          3、如无特别说明，本协议提及的条款，均是指本协议的条款。
        </span>
        <div class="text_14">服务说明</div>
        <span class="text_12">
          1、您使用“好声音学院”相关服务，可以通过已授权的平台或网站等渠道访问好声音学院相关网站。若您并非从官方或经官方授权的第三方获取本网站的，公司无法保证相关网站的安全及可靠，您因此遭受的损失与公司无关。
          2、为更好的提升您体验及服务，公司将不定期提供网站更新或改变（包括但不限于网站修改、升级、功能强化、开发新服务、网站替换等）。为保证“好声音学院”网站及相关服务安全、提升您服务，本网站及相关服务更新或部分服务内容更新后，在可能的情况下，公司将以包括但不限于系统提示、公告、站内信等方式提示您，您有权选择接受更新版本或服务，如您不接受，部分功能将受到限制、负面影响或不能继续使用。
          3、除非得到公司明示事先书面授权，您不得以任何形式对“好声音学院”网站及相关服务进行包括但不限于：
          3.1反向编译、反向汇编、改编、删除软件著作权、复制、传播、垂直搜索、镜像或交易等未经授权的访问或使用。
          3.2不得以任何形式对“好声音学院”公司拥有知识产权的内容进行使用出租，出借、复制、汇编、出版，以及借助本网站相关信息发展相关信息衍生品，作品、插件、外挂、兼容、互联等。
          3.3好声音学员网站运行数据，以及交互数据，以及系统数据进行复制、修改、增加、删除、挂接运行以及发展与之相关的一些衍生品、作品、服务、插件、外挂、或经非官方授权的第三方工具接入软件和相关系统等；
          3.4 本网站可能会使用第三方软件和技术，这种使用已经获得合法授权。 3.5
          本网站使用的第三方软件和技术引发的任何纠纷，应由第三方负责解决，本公司承担任何责任。
          4、您理解，您使用“好声音学院”网站及相关服务需自行准备与网站及相关服务有关的终端设备（如电脑、手机等装置），一旦您在其终端设备中打开“好声音学院”网站或访问好声音学院相关网站，即视为您使用“好声音学院”网站及相关服务。为充分实现“好声音学院”的全部功能，您可能需要将其终端设备联网，您理解由您承担所需要的费用（如流量费、短信费、上网费等）。
          5、为使您更好地使用“好声音学院”网站及相关服务，保障您的账号安全，某些功能和/或某些服务项目，您需要按照国家相关法律法规的规定，注册并登陆后方可使用。好声音学院提供的在线课程服务，与学习在线课程相关的设备及网络条件，均由您自行负担。
          6、您了解并同意，本服务仅依其当前所呈现的状况提供，好声音学院会尽可能维持系统及服务的稳定及持续，但对于任何您上传信息或由您个性化设定之时效、删除、传递错误、未予储存或其它任何问题，好声音学院均不做任何保证。好声音学院保留不经事先通知为紧急维修保养、升级或其它合理目的暂停本服务整体或任何部分的权利,并无需承担任何责任。
          7、好声音学院网站通过第三方软件向您提供在线音视频录制、音频调整、合成及网络存储空间服务（以下简称“本服务”）。您在好声音学院网站自行上传的所有内容（包括但不限于文字、图片、音频、视频等），您应享有相关知识产权或经过第三方合法授权。您在此授权好声音学院对您上传的所有内容享有永久的、免费的使用权，包括但不限于复制、发表、修改、汇编、展示、翻译等，以及以现在已知或日后开发的任何形式或技术，将上述内容纳入其它作品内或制作其他衍生作品。
        </span>
        <div class="text_14">用户行为规范</div>
        <span class="text_12">
          1、在使用好声音学院服务过程中，您承诺遵守下列使用规范：
          您在好声音学院网站和小程序发布、评论、发布、传播的内容（包括但不限于上传至“好声音学院”平台的未公开的私密音频）应自觉遵守法律法规、社会主义道德风尚和信息真实性等要求，否则公司将立即采取包括但不限拒绝发布、立即停止传输信息、删除音频、图片等内容、扣罚虚拟货币、限制账号部分或者全部功能、永久关闭账号等措施。
          2、您单独承担发布内容的责任，并承诺在使用好声音学院的服务时必须符合中国有关法规。
          您不得利用好声音学院的服务制作、复制、发布、传播以下信息：
          1）有违宪法确定的基本原则的； 2）危害国家统一、主权和领土完整的；
          3）泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；
          4）煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；
          5）宣扬邪教、迷信的； 6）扰乱社会秩序，破坏社会稳定的；
          7）诱导未成年人违法犯罪和渲染暴力、色情、赌博、恐怖活动的；
          8）侮辱或者诽谤他人，侵害公民个人隐私等他人合法权益的；
          9）危害社会公德，损害民族优秀文化传统的；
          10）有关法律、行政法规和国家规定禁止的其他内容。
          如您的行为涉嫌违反国家法律和法规的相关规定，好声音学院将视情况对您的服务进行调整。对于您的行为有可能构成犯罪的，好声音学院将会主动将您的相关信息、具体行为及相应证据报送给国家公安机关或对应有执法权的主管机关部门，您可能将被追究刑事责任，并由您承担全部法律责任。
          3、注册、账号及密码
          3.1、基于网络服务的特性及重要性，您理解并承诺，您所设置的账号不得违反国家法律法规及公司的相关规则，若您提交的材料或提供的信息不准确、不真实、不合法或者公司有理由怀疑为错误、不实或不合法的资料，则公司有权拒绝为您提供相关服务或您可能无法使用“好声音学院”网站及相关服务或在使用过程中部分功能受到限制。
          3.2、您在“好声音学院”中的注册账号本身的所有权及有关权益均归公司所有，您完成注册手续后仅享有该账号的使用权。您不应将其帐号、密码转让或出借予他人使用。您的账号仅限于您本人使用，未经公司书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。如果公司发现或者有合理理由认为使用者并非账号初始注册人，公司有权在未通知您的情况下，暂停或终止向该注册账号提供服务，并有权注销该账号，而无需向注册该账号的用户承担法律责任。
          3.3、您理解维护个人账号、密码的安全性与保密性是您本身而非公司的义务，因其他人恶意攻击或您自身原因或其他不可抗因素而导致账号被盗、丢失，均由您本人承担责任，公司不承担任何责任。您需对您以注册账号名义所从事的活动承担全部法律责任，包括但不限于您在“好声音学院”上进行的任何数据修改、言论发表、款项支付等操作行为。如您发现其帐号遭他人非法使用，应立即通知好声音学院。因黑客行为或您的保管疏忽导致帐号、密码遭他人非法使用，好声音学院不承担任何责任。
          3.4、因您开通某项功能选择或者同意，您理解并且同意，除您登录、使用“好声音学院”软件及相关服务外，您还可能用“好声音学院”账号登录使用公司及其关联公司或其他合作方提供的其他软件、服务。
          3.5、您同意好声音学院有权在提供网络服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息（包括但不限于在好声音学院产品的任何页面上投放广告），并且您同意接受好声音学院通过短信、电子邮件或其他方式向您发送产品促销或其他相关商业信息。
          3.6、对于您通过好声音学院网络服务（包括但不限于论坛、BBS、评论、个人微博）上传到好声音学院上可公开获取区域的任何内容，您同意好声音学院在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的权利和许可，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。
        </span>
        <div class="text_14">隐私政策</div>
        <span class="text_12">
          好声音学院深知个人信息对用户的重要性，好声音学院将按照法律法规等的要求，采取相应安全保护措施，尽力保护用户的个人信息安全可控。好声音学院承诺将按照本隐私政策收集、使用和披露用户信息，本隐私政策适用于好声音学院的所有产品及服务。
          在使用好声音学院各项产品或服务前，请用户务必仔细阅读并透彻理解本政策，在确认充分理解并同意后使用相关产品或服务。一旦用户开始使用好声音学院各项产品或服务，即表示用户已充分理解并同意本政策。
          1、您理解并同意，公司有权在遵守法律法规、本协议以及《“好声音学院”隐私权政策》的前提下，收集、使用（含商业合作使用）、存储和分享您的个人信息，同时，我们将依法保护您浏览、修改、删除相关个人信息以及撤回同意的权利。
          2、为保障您正常使用我们的服务，维护我们服务的正常运行，改善及优化您的服务体验并保障您的账号安全，我们会收集您的设备型号、操作系统、唯一设备标识符、登录IP地址、MAC地址、操作日志等信息。我们可能通过cookie或同类技术收集您的信息，包括您的设备信息、浏览信息、点击信息，并将该等信息储存为日志信息，用于记住您的身份、分析您使用我们服务的情况、优化广告投放。您可以通过浏览器设置拒绝或管理cookie或同类技术的使用。其中，我们会使用手机系统等提供的专门的软件开发工具包为您推送推荐及活动信息，这些工具包可能会收集您的设备信息用于实现上述推送；我们还会使用开发工具包进行播放统计，该工具包可能会收集去除您身份及账号信息的使用日志用于完成上述统计。
          3、您在上传作品时，如果使用其他的配乐、伴奏、照片等可能涉及第三方版权及其他权利的内容配合录制并上传，则您需要确认对该配乐和伴奏、照片等享有相应使用权，否则好声音学院可删除您上传的内容。
          4、另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：
          1）与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公共知情等重大公共利益直接相关的；
          2）与犯罪侦查、起诉、审判和判决执行等直接相关的；
          3）出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；
          4）所收集的个人信息是您自行向社会公众公开的；
          5）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
          6）根据您要求签订和履行合同所必需的；
          7）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
          8）为开展合法的新闻报道所必需的；
          9）出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
          10）法律法规规定的其他情形。 5、用户信息的共享
          为便于好声音学院基于关联账号共同向用户提供服务，用户的个人信息可能会与好声音学院的关联公司共享。
          如果某些服务将由好声音学院和授权合作伙伴共同完成，好声音学院可能会与合作伙伴共享用户的某些个人信息，好声音学院仅会出于合法、正当、必要、特定、明确的目的共享用户的个人信息，并且只会共享提供服务所必要的个人信息。好声音学院会与其合作伙伴签署严格的数据保护协定，要求他们按照本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息，好声音学院的合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途。
          6、数据使用规范
          6.1、未经公司书面许可，您不得自行或授权、允许、协助任何第三人对本协议“好声音学院”网站及相关服务中信息内容进行如下行为：
          （1）复制、读取、采用“好声音学院”网站及相关服务的信息内容，用于包括但不限于宣传、增加收听量等商业用途；
          （2）擅自编辑、整理、编排“好声音学院”网站及相关服务的信息内容后在好声音学院网站及相关服务的源页面以外的渠道进行展示；
          6.2、好声音学院存储和备份的用户个人信息将保留在托管的服务器上。
          7、未成年人保护
          我们非常重视对未成年人个人信息的保护。我们会根据相关法律法规的规定，要求不满十四周岁的未成年人在使用好声音学院的服务或向我们提供个人信息前，应当事先取得自己的监护人（比如自己的父母）的授权同意；已满十四周岁未满十八周岁的未成年人，可以事先取得自己的监护人的授权同意或自行授权同意。
          我们仅在法律法规允许、未成年人的监护人明确同意或者有必要保护未成年人的情况下使用、对外提供或公开披露该信息。
          若您是未成年人的监护人，请您关注您监护的未成年人是否是在取得您的授权同意之后使用好声音学院的服务。如果您对您所监护的未成年人的个人信息有疑问，请通过官方联系方式与我们联系。
          8、责任限制
          您明确了解并同意，基于以下原因而造成的，包括但不限于利润、信誉、应用、数据损失或其它无形损失，好声音学院不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿责任：
          1）本服务之使用或无法使用；
          2）为替换从或通过本服务购买或取得之任何商品、数据、信息、服务，收到的讯息，或缔结之交易而发生的成本；
          3）您的传输或数据遭到未获授权的存取或变造；
          4）任何第三方在本服务中所作之声明或行为；
          5）与本服务相关的其它事宜，但本使用协议有明确规定的除外；
          6）第三方以任何方式发布或投递欺诈性信息，或诱导用户受到经济损失，好声音学院不承担任何责任。
          9、版权声明
          好声音学院尊重他人著作权，并在好声音学院服务条款中明定网友使用好声音学院服务不得侵害他人之著作权。因此，好声音学院郑重呼吁使用者尊重他人之著作权。如果您发现好声音学院网站中之任何网页内容或网友使用好声音学院服务已侵害您的著作权，建议您利用本处理办法提出检举，好声音学院客服中心将尽快为您处理。
          若好声音学院网站中之任何内容或网友使用好声音学院服务已侵害您的著作权，请及时发送邮件到contact@singchina提供所需之资料及声明。
          好声音学院在接获您的通知后，将尽快移除您所主张涉有侵害著作权之内容。
          除经使用者同意或于提供服务之目的者外，好声音学院仅得依法令或政府机关之要求，提供使用者之识别资料予第三人。因之，您如依本办法提出检举，好声音学院仅会依您的请求移除该侵权内容，而不会提供您有关该使用者之识别资料。您如欲取得该使用者资料，您应向地方法院检察署或刑事警察局提出告诉，好声音学院将于前开单位来函要求提供使用者资料后即刻配合。
          10、联系我们
          当您有其他的投诉、建议、未成年人个人信息相关问题时，请通过邮件联系contact@singchina.com，我们将尽快审核所涉问题，并在验证您的用户身份后的十天内予以回复。
        </span>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data() {
    return {};
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.page {
  background: #fff;
  overflow-y: scroll;

  .service_contract {
    width: 800px;
    margin: 20px auto;
    padding: 18px;
    font-size: 20px;
    line-height: 28px;
    box-shadow: 0px 0px 20px #cccccc;
    .service_title {
      text-align: center;
      margin-top: 30px;
      margin-bottom: 30px;
      color: #262020;
      font-size: 28px;
      font-weight: 600;
    }
    .service_nav {
      white-space: pre-wrap; /*css-3*/
      white-space: -moz-pre-wrap; /*Mozilla,since1999*/
      white-space: -pre-wrap; /*Opera4-6*/
      white-space: -o-pre-wrap; /*Opera7*/
      word-wrap: break-word; /*InternetExplorer5.5+*/
      .text_14 {
        font-size: 18px;
        line-height: 0.2rem;
        color: #262020;
        text-align: left;
        margin: 0.11rem 0 0.07rem 0rem;
        font-weight: 600;
      }
      .text_12 {
        font-size: 16px;
        line-height: 22px;
        color: #808080;
        text-align: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/agreement/agreement.vue